import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, IconButton } from '@mui/material';
import { RemoveCircleOutlined as DeleteIcon } from '@mui/icons-material';

import { useTreatmentPlanEditable } from '../hooks/useTreatmentPlanEditable';
import { FHInputField } from '../../../base';
import { Themes } from '../../../../constants';
import { FORTA_BLUE } from '../../../../utils/colors';

import type { IReferralAssessmentTool } from '../../../../utils/types';

interface ToolRowProps {
  tool?: IReferralAssessmentTool;
  onSave: (tool: IReferralAssessmentTool) => void;
  onRemove: () => void;
}

function ToolRow({ tool, onSave, onRemove }: ToolRowProps) {
  const { referralHistoryLoading } = useSelector((state: any) => state.medicalHistories);
  const editable = useTreatmentPlanEditable();
  const [toolInfo, setToolInfo] = useState<IReferralAssessmentTool>({
    tool_name: '',
  });

  useEffect(() => {
    if (!tool) return;
    setToolInfo(tool);
  }, [tool]);

  const handleFieldUpdate = (field: string, value: string) => {
    const updatedData = { ...toolInfo, [field]: value };
    setToolInfo(updatedData);
  };

  return (
    <Box mb={2} sx={{ display: 'flex', width: '100%' }}>
      {editable && (
        <IconButton
          sx={{ p: 0, mr: 1 }}
          disabled={referralHistoryLoading}
          onClick={onRemove}
          data-testid="deleteTool"
        >
          <DeleteIcon sx={{ color: FORTA_BLUE.primary }} />
        </IconButton>
      )}
      <Box sx={{ flex: '1' }}>
        <FHInputField
          data-testid="toolsRow"
          value={toolInfo.tool_name}
          fullWidth
          disabled={!editable}
          inputHeight={40}
          colorTheme={Themes.Primary}
          onChange={(e) => handleFieldUpdate('tool_name', e.target.value)}
          onBlur={() => onSave(toolInfo)}
          error={toolInfo.tool_name.length < 2}
        />
      </Box>
    </Box>
  );
}

export default ToolRow;
